module.exports = __webpack_public_path__ + "static/media/shared-icon.9e0daf4f.png";